import React from 'react';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';

const WorkersList = ({ eligibleWorkers, handleEngineerSelect, selectedWorker }) => {

    return <motion.div
        className="flex-1 min-h-0"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
    >
        <h3 className="text-lg font-semibold mb-4 text-blue-500">Available Engineers</h3>
        <div className="bg-white rounded-lg shadow max-h-max flex flex-col">
            <div className="bg-gray-300 border border-gray-300">
                <table className="min-w-full">
                    <thead>
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">Engineer Name</th>
                            <th className="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">Mobile</th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div style={{ maxHeight: '15rem' }} className="overflow-y-auto flex-1 border border-t-0 border-gray-300">
                <table className="min-w-full">
                    <tbody className="bg-white divide-y divide-gray-200">
                        {eligibleWorkers.map((engineer, idx) => (
                            <motion.tr
                                key={engineer.id}
                                initial={{ opacity: 0, x: -20 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: idx * 0.1 }}
                                className="hover:bg-gray-50 cursor-pointer"
                                onClick={() => handleEngineerSelect(engineer)}
                            >
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            checked={selectedWorker && selectedWorker.id === engineer.id}
                                            onChange={() => handleEngineerSelect(engineer)}
                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded-full"
                                        />
                                        <span className="ml-3 text-sm text-gray-900">{engineer.full_name}</span>
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{engineer.mobile}</td>
                            </motion.tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    </motion.div>
};

export default WorkersList;